import React from "react";
import { MDBRow } from "mdbreact";
import SingleCard from "./SingleCard.jsx";
import { Slide } from "react-reveal";

const getProjects = (projects, props) => {
  let limit = 2;
  let pages = projects.chunk(limit);

  return (
    <Slide bottom cascade duration={3000}>
      {pages.map((prop, key) => getItem(prop, key + 1, props))}
    </Slide>
  );
};

const getItem = (projectList, id, props) => {
  return (
    <MDBRow
      style={{
        padding: "10px 50px 50px 50px",
        display: "flex",
        alignItems: "stretch",
      }}
    >
      {projectList.map((prop, key) => {
        return (
          <SingleCard
            key={key}
            path={prop.path ? prop.path : ""}
            icon={prop.icon ? prop.icon : ""}
            service={prop.service ? prop.service : ""}
            title={prop.title ? prop.title : ""}
            description={prop.description ? prop.description : ""}
            servicesButton={props.servicesButton}
          />
        );
      })}
    </MDBRow>
  );
};

const MCard = (props) => {
  return (
    <div className="container">
      {/* <Slide  bottom cascade duration={3000}>
      <MDBRow >
      
        {
          props.cards.map((prop, key) => {
            return(
            
            <SingleCard 
            key={key}
            path={prop.path}
            icon={prop.icon}
            service={prop.service}
            title={prop.title}
            description={prop.description}
            servicesButton={props.servicesButton}
            />
            )
          })
        }
       
      </MDBRow>
      </Slide > */}
      {getProjects(props.cards, props)}
    </div>
  );
};

export default MCard;



// WEBPACK FOOTER //
// ./src/components/MDBCard/MDBCard.jsx